import { Add, PedalBike as IconBike } from "@mui/icons-material";
import { Button, darken, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlPlannerV2TransportationMethod } from "~/__generated__/graphql/types.ts";
import { theme } from "~/config/theme";
import { formatKilometers, formatSeconds } from "~/modules/app/util/formatters.ts";

import { GaiaExpandableMapMarkerFieldworkerAvailableTransportationMethodsFragment } from "./fragments.generated";

type GaiaExpandableMapMarkerFieldworkerBodyAddToVisitButtonProps = {
    availableTransportationMethod: GaiaExpandableMapMarkerFieldworkerAvailableTransportationMethodsFragment;
    onClick: (transportationMethod: GqlPlannerV2TransportationMethod) => void;
    disabled: boolean;
    hasMoreThanOneOption: boolean;
};

export function GaiaExpandableMapMarkerFieldworkerBodyAddToVisitButton({
    availableTransportationMethod,
    onClick,
    disabled,
    hasMoreThanOneOption,
}: GaiaExpandableMapMarkerFieldworkerBodyAddToVisitButtonProps) {
    const { t } = useTranslation("plannerV2");

    const { transportationMethod, distanceInMeters, durationInSeconds } = availableTransportationMethod;

    return (
        <Button
            startIcon={<Add />}
            disabled={disabled}
            onClick={() => onClick(transportationMethod)}
            sx={{
                textTransform: "none",
                textAlign: "left",
                justifyContent: "start",

                borderRadius: 0,
                borderTop: `1px solid ${theme.palette.divider}`,
                color: theme.palette.primary.main,

                backgroundColor: theme.palette.background.default,
                "&:hover": {
                    backgroundColor: darken(theme.palette.background.default, 0.03),
                },
            }}
        >
            <Stack>
                <Typography>{t("addToVisitButton.addToVisit")}</Typography>

                {hasMoreThanOneOption && transportationMethod === GqlPlannerV2TransportationMethod.Bike && (
                    <Stack flexDirection={"row"} alignItems={"center"} columnGap={0.5}>
                        <IconBike sx={{ fontSize: 14 }} />

                        <Typography variant="caption">
                            {t("addToVisitButton.asBiker", {
                                distanceInKm: formatKilometers(distanceInMeters),
                                durationInMinutes: formatSeconds(durationInSeconds),
                            })}
                        </Typography>
                    </Stack>
                )}
            </Stack>
        </Button>
    );
}
